import { render } from "./ConsignmentsTableFilter.vue?vue&type=template&id=96515c5a"
import script from "./ConsignmentsTableFilter.vue?vue&type=script&lang=ts"
export * from "./ConsignmentsTableFilter.vue?vue&type=script&lang=ts"
script.render = render

export default script